import { getCurrentUrlParameter } from 'utils/url';

/**
 * Determines if the application is running in debug mode.
 * Debug mode is enabled when:
 * - Running in development mode
 * - URL contains 'test' parameter
 * - URL contains 'dev' parameter
 * - Environment stage is not 'prod'
 */
export function isDebugMode(): boolean {
  return (
    import.meta.env.MODE === 'development' ||
    testDataRequested() ||
    !!getCurrentUrlParameter('dev') ||
    process.env.STAGE !== 'prod'
  );
}

/**
 * In test data mode we may use additional or fallback data for testing purposes
 */
export function testDataRequested(): boolean {
  return !!getCurrentUrlParameter('test');
}
